import React from 'react';

import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller } from 'react-hook-form';

import { type ControlledCheckboxProps } from './types';

export const ControlledCheckbox: React.FC<ControlledCheckboxProps> = (props) => (
    <Controller
        name={props.name}
        control={props.control}
        render={({ field }) => (
            <FormControlLabel
                label={props.label}
                control={
                    <Checkbox
                        {...field}
                        {...props}
                        ref={props.ref}
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                    />
                }
            />
        )}
    />
);

export default ControlledCheckbox;
